
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateVHostForm from '@/services/Vhost/CDN/forms/CreateVHostForm';
import CDNVhostRepositoryInterface from 'src/services/Vhost/CDN/Interfaces';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import WebsiteRepositoryInterface, { Website } from '@/services/Website/interfaces';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  inject: [
    'cdnVhostRepository',
    'serverRepository',
    'websiteRepository',
  ],
  components: {
    PageHeader,
  },
})
export default class CreateVHost extends Vue {
  private readonly cdnVhostRepository!: CDNVhostRepositoryInterface;
  private readonly serverRepository!: ServerRepositoryInterface;
  private readonly websiteRepository!: WebsiteRepositoryInterface;

  private loading: boolean = true;

  private form: WPXFormValue<CreateVHostForm> = new WPXFormValue<CreateVHostForm>(CreateVHostForm);
  private servers: ServerInterface[] = [];
  private vhostTypes: Array<{ key: string, value: string }> = [
    { key: 'domain', value: 'Domain' },
    { key: 'alias', value: 'Alias' },
  ];

  private websites: Website[] = [];
  public _websiteSearch: string = '';
  public websiteSearchLoading: boolean = false;


  public async created(): Promise<void> {
    this.servers = await this.serverRepository.getServersOfType('OriginServer');
    this.loading = false;
  }

  private updateIpField(): void {
    const selectedServer = this.servers.find(
      (server: ServerInterface) => server._id === this.form.data.originServerHostname,
    );
    if (selectedServer && selectedServer.config && selectedServer.config.ips) {
      this.form.data.serverIps = selectedServer.config.ips;
    }
  }

  public get websiteSearch(): string {
    return this._websiteSearch;
  }

  public set websiteSearch(val: string) {
    if (val && val.length < 3) {
      return;
    }

    this._websiteSearch = `server=${this.form.data.originServerHostname}&domain=${val}`;
    this.websiteSearchLoading = true;
    this.websiteRepository.getByServerAndDomain(this.form.data.originServerHostname, val).then((websites) => {
      this.websites = websites;
      this.websiteSearchLoading = false;
    }).catch((err) => {
      this.$errorDialog.show(err.message);
    });
  }

  private async addVhost(): Promise<void> {
    try {
      const domain = this.websites.find((website) => website.id === this.form.data.websiteId)?.domain;
      if (!domain) {
        this.$errorDialog.show('Website Not Found!');
        return;
      }

      await this.cdnVhostRepository.createVhost({
        domain,
        websiteId: this.form.data.websiteId,
        originServerHostname: this.form.data.originServerHostname,
        ip: this.form.data.serverIps,
        xdnEnabled: this.form.data.xdnEnabled,
      });

      this.$successDialog.show(`Vhost ${domain} has been added`);
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
    }
  }
}
